export const avaAnchor = {
	id: ``,
	icon: 'sparkles',
	text: 'App.AIChat.Name',
	tooltip: 'App.AIChat.Title',
	aStyle: {
		transform: 'rotate(-90deg) translate(2px,0px)',
		justifyContent: 'space-evenly',
		transformOrigin: '50px 0px 0px',
		fontSize: '20px',
		width: '100px',
		// override because rotated
		borderRadius: '0',
		borderTopLeftRadius: '0.3rem',
		borderTopRightRadius: '0.3rem',
	},
}

export function objectToStyleAttribute(styleObj: Record<string, string>) {
	return JSON.stringify(styleObj || {}, null, '\t')
		.replace(/"/g, '')
		.replace(/,\n/g, ';')
		.replace(/\}/g, ';}')
		.replace(/^{/, '')
		.replace(/}$/, '')
}

export function linkButton(text: string, href: string) {
	return `<div style="padding: 10px 0;">${link(text, href)}</div>`
}

export function link(text: string, href: string, color = '#155aa7') {
	return `<span style="color: ${color}; cursor: pointer" onclick="window.navigateByUrl('${href}')" class="app-link">${text}</span>`
}

export function suggestionButton(html: string) {
	return `<button class="ai-chat-button ai-chat-suggestion-button">${html}</button>`
}

export function temporaryText(html: string) {
	return `<div class="ai-chat-temporary-message">${html}</div>`
}

export function systemMessage<M extends Record<string, unknown>>(props: M) : M & { role: 'system' } {
	return {
		...props,
		role: 'system',
	}
}

export interface AiChatMenuItem {
	label: string
	onClick: () => void
}

// Custom toolbar button model for AIChatBoxComponent.customButtons.
// 'toolbar-start'/'toolbar-end' render as standalone icon buttons; 'menu' entries
// render as quick-prompt chips in a wrapped row above the chat input (used for pre-prompt shortcuts).
// A 'menu' entry with 'items' renders as a category chip that opens a submenu of those items instead
// of firing onClick directly.
export interface AiChatButton {
	id: string
	position: 'toolbar-start' | 'toolbar-end' | 'menu'
	icon?: string
	label?: string
	tooltip?: string
	hidden?: () => boolean
	onClick: () => void
	items?: AiChatMenuItem[]
}

export const exportIcon = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
		<path d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width="3" fill="none"></path>
	</svg>
`

export const trashIcon = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16">
		<path fill="currentColor" d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
	</svg>
`

export const copyIcon = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
		<path d="M8 16V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H16M5.2 16H12.8C13.9201 16 14.4802 16 14.908 15.782C15.2843 15.5903 15.5903 15.2843 15.782 14.908C16 14.4802 16 13.9201 16 12.8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.07989 16 5.2 16Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
	</svg>
`

export const penIcon = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none">
		<path d="M15.4998 5.49994L18.3282 8.32837M3 20.9997L3.04745 20.6675C3.21536 19.4922 3.29932 18.9045 3.49029 18.3558C3.65975 17.8689 3.89124 17.4059 4.17906 16.9783C4.50341 16.4963 4.92319 16.0765 5.76274 15.237L17.4107 3.58896C18.1918 2.80791 19.4581 2.80791 20.2392 3.58896C21.0202 4.37001 21.0202 5.63634 20.2392 6.41739L8.37744 18.2791C7.61579 19.0408 7.23497 19.4216 6.8012 19.7244C6.41618 19.9932 6.00093 20.2159 5.56398 20.3879C5.07171 20.5817 4.54375 20.6882 3.48793 20.9012L3 20.9997Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
`

export const chatTrashButton: Omit<AiChatButton, 'onClick'> = {
	id: 'trash',
	position: 'toolbar-end',
	icon: trashIcon,
	tooltip: 'Actions.Clear',
}

export const chatExportButton: Omit<AiChatButton, 'onClick'> = {
	id: 'export',
	position: 'toolbar-end',
	icon: exportIcon,
	tooltip: 'Actions.Export',
}

export const chatCopyButton: Omit<AiChatButton, 'onClick' | 'position'> = {
	id: 'copy',
	icon: copyIcon,
	tooltip: 'Actions.Copy',
}

export const prePromptDropdown = (label: string): Omit<AiChatButton, 'onClick'> => ({
	id: `prompt-${label}`,
	position: 'menu',
	icon: penIcon,
	label,
})

export const promptCategory = (label: string, items: AiChatMenuItem[]): AiChatButton => ({
	id: `prompt-category-${label}`,
	position: 'menu',
	icon: penIcon,
	label,
	items,
	onClick: () => {},
})
